import CompleteProfile from "../../component/CompleteProfile";

function AccountManagementModel() {
  return <CompleteProfile />;
}

export default AccountManagementModel;
